import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Amplify } from "aws-amplify";
import "@aws-amplify/ui-react/styles.css";

import App from "./App";
import { ThemeProvider } from "./theme";
import { cargarConfig, callbackUrl, PortalConfig } from "./config";
import "./index.css";

/**
 * Amplify se configura DESPUÉS de leer `/config.json`, no al importar el
 * módulo: los valores del pool ya no vienen horneados en el bundle. Ver
 * `config.ts` para por qué.
 */
function configurarAmplify(cfg: PortalConfig) {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: cfg.userPoolId,
        userPoolClientId: cfg.userPoolClientId,
        // El bloque oauth solo hace falta para el login con Google. Amplify
        // exige `domain` no vacio, asi que si no esta configurado se omite
        // entero: sin esto el formulario de email+contrasena tambien falla.
        ...(cfg.cognitoDomain
          ? {
              loginWith: {
                oauth: {
                  domain: cfg.cognitoDomain,
                  scopes: ["openid", "email", "profile"],
                  // Google vuelve a la raiz del sitio; el SPA lee el codigo de
                  // la query. Sale del origen del navegador porque tiene que
                  // coincidir con los callback_urls del User Pool Client en
                  // dashboard_stack.py, y esos son justamente las URLs desde
                  // las que se abre el portal.
                  redirectSignIn: [callbackUrl()],
                  redirectSignOut: [callbackUrl()],
                  responseType: "code" as const,
                },
              },
            }
          : {}),
      },
    },
  });
}

const raiz = ReactDOM.createRoot(document.getElementById("root")!);

cargarConfig()
  .then((cfg) => {
    configurarAmplify(cfg);
    raiz.render(
      <React.StrictMode>
        <BrowserRouter>
          <ThemeProvider>
            <App />
          </ThemeProvider>
        </BrowserRouter>
      </React.StrictMode>
    );
  })
  .catch((e) => {
    // Sin config no hay login ni API: la pantalla en blanco no le dice a nadie
    // que el problema es un archivo que falta en el bucket.
    raiz.render(
      <div style={{ padding: 32, fontFamily: "system-ui, sans-serif",
                    maxWidth: 560, margin: "10vh auto", lineHeight: 1.6 }}>
        <h1 style={{ fontSize: 18 }}>El portal no pudo arrancar</h1>
        <p style={{ fontSize: 14, color: "#666" }}>{String(e?.message ?? e)}</p>
      </div>
    );
  });
